import { AppShell } from '@mantine/core'
import { PageProps } from 'gatsby'
import { FC } from 'react'
import { Notifications } from '@mantine/notifications'
import TopBar from './TopBar'
import * as classes from './selfEnrollmentLayout.module.css'

const SelfEnrollmentLayout: FC<PageProps> = ({ children }) => {
  return (
    <AppShell
      padding="md"
      navbar={{ width: 140, breakpoint: 0, collapsed: { mobile: false } }}
      header={{ height: 52 }}
    >
      <AppShell.Main className={classes.mainContainer}>
        <TopBar />
        {children}
      </AppShell.Main>
      <Notifications position="bottom-right" />
    </AppShell>
  )
}

export default SelfEnrollmentLayout
